import { render, staticRenderFns } from "./UploadFileErrors.vue?vue&type=template&id=47123c1c&"
import script from "./UploadFileErrors.vue?vue&type=script&lang=js&"
export * from "./UploadFileErrors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports